import { render, staticRenderFns } from "./SubscriptionList.vue?vue&type=template&id=0f1c048e&scoped=true"
import script from "./SubscriptionList.vue?vue&type=script&lang=js"
export * from "./SubscriptionList.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionList.vue?vue&type=style&index=0&id=0f1c048e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1c048e",
  null
  
)

export default component.exports